import React from "react";
import Box from "react-raster";
import styled from "styled-components";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { H2, Copy, Eyebrow, AccentTitle } from "../Typography";
import Container from "../Container";
import Arrow, { ArrowContainer, arrowHoverStyles } from "../Arrow";

const HorizontalSpacer = styled.div`
  padding: 20px 0 0 0;
  margin: 0;
  @media (${({ theme }) => theme.mq.m}) {
    padding: 0;
  }
`;

const LinkWrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colours.lightestGray};
  padding-top: 20px;
  color: ${({ theme }) => theme.colours.grey};
  display: flex;
  align-items: center;
  margin-top: 40px;
`;

const StyledLink = styled(Link)`
  display: flex;
  text-decoration: none;
  display: flex;
  align-items: center;
  ${arrowHoverStyles}
`;

const CtaLabel = styled(AccentTitle)`
  color: ${({ theme, $foregroundColour }) => theme.colours[$foregroundColour]};
  margin-left: 16px;
  margin: 0 0 0 16px;
  padding: 0;
`;

const FullWidthWrapper = styled.div`
  background-color: ${({ theme, $backgroundColour }) =>
    theme.colours[$backgroundColour]};
  width: 100%;
  padding-bottom: ${({ $hasBottomMargin }) =>
    $hasBottomMargin ? "60px" : "20px"};
  padding-top: ${({ $hasTopMargin }) => ($hasTopMargin ? "60px" : "20px")};
  align-items: center;
`;

function TwoColumnWithImage({
  backgroundColour,
  eyebrow,
  title,
  description,
  hideTitle,
  image,
  imageRight,
  ctaUrl,
  ctaLabel,
  ctaChatbotIdentifier,
  hasBottomMargin,
  hasTopMargin,
}) {
  const isNonDefaultBackgroundColour =
    backgroundColour &&
    backgroundColour !== "default" &&
    (backgroundColour === "alabasterWhite" || backgroundColour === "white");
  const foregroundColour = isNonDefaultBackgroundColour ? "black" : "white";

  return (
    <FullWidthWrapper
      $backgroundColour={backgroundColour}
      $hasBottomMargin={hasBottomMargin}
      $hasTopMargin={hasTopMargin}
    >
      <Container marginLeft={["30px", 0]} marginBottom={["30px", 0]}>
        <Box
          cols={[6]}
          marginLeft={0}
          marginRight={0}
          order={imageRight ? 2 : 1}
        >
          <GatsbyImage image={getImage(image)} />
        </Box>
        <Box cols={[6]} order={imageRight ? 1 : 2}>
          {!imageRight && <HorizontalSpacer />}
          {eyebrow && <Eyebrow colour={foregroundColour}>{eyebrow}</Eyebrow>}
          {!hideTitle && (
            <H2 $colour={foregroundColour} marginBottom={[20]}>
              {title}
            </H2>
          )}
          <Copy colour={foregroundColour}>{description}</Copy>
          {(ctaUrl || ctaChatbotIdentifier) && (
            <LinkWrapper>
              <StyledLink
                to={ctaUrl}
                onClick={(event) => {
                  if (ctaChatbotIdentifier) {
                    event.preventDefault();
                    window.LeadBooster && window.LeadBooster.trigger("open");
                  }
                }}
              >
                <ArrowContainer
                  $isReversed={isNonDefaultBackgroundColour}
                  $backgroundColour={
                    isNonDefaultBackgroundColour ? "black" : "white"
                  }
                >
                  <Arrow
                    colour={isNonDefaultBackgroundColour ? "white" : "black"}
                    transform="rotate(-90deg)"
                  />
                </ArrowContainer>
                <CtaLabel $foregroundColour={foregroundColour}>
                  {ctaLabel}
                </CtaLabel>
              </StyledLink>
            </LinkWrapper>
          )}
          {imageRight && <HorizontalSpacer />}
        </Box>
      </Container>
    </FullWidthWrapper>
  );
}

export default TwoColumnWithImage;
